import { render, staticRenderFns } from "./historyView.vue?vue&type=template&id=16c5c386&scoped=true&"
import script from "./historyView.vue?vue&type=script&lang=js&"
export * from "./historyView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c5c386",
  null
  
)

export default component.exports